/**
 * Utility function to get endpoint key from copilot state
 * Checks edit mode (ui.endpointKey) first, then create mode (endpointKey)
 */
export const getEndpointKey = (copilotState: {
  ui?: { endpointKey?: string | null };
  endpointKey?: number | null;
}): number | null => {
  // Edit mode: check ui.endpointKey first (string)
  if (copilotState.ui?.endpointKey) {
    return Number(copilotState.ui.endpointKey);
  }

  // Create mode: fallback to endpointKey (number)
  if (copilotState.endpointKey) {
    return copilotState.endpointKey;
  }

  return null;
};

export default getEndpointKey;
